export enum TransactionsTableAccessor {
  Amount = 'amount',
  Attachment = 'hasVoucher',
  CreatedBy = 'createdBy',
  CreatedDate = 'createdTime',
  Currency = 'currency',
  Description = 'description',
  EntryDate = 'entryDate',
  JournalCode = 'journalCode',
  JournalName = 'journalName',
  Origin = 'originUrl',
  OriginatorTypeKey = 'originatorTypeKey',
  TransactionNo = 'transactionNo',
  Voided = 'voided',
  VoucherNo = 'voucherNo',
}
